import { queryAll } from './dom.js';

export function initAddOns() {
  queryAll('[data-add-on-group]').forEach(group => {
    const mode = group.dataset.mode || 'single';
    const max  = parseInt(group.dataset.max, 10) || Infinity;

    if (mode === 'single') {
      initSingleGroup(group);
    } else if (mode === 'gift-card') {
      initGiftCardGroup(group);
    } else {
      initMultipleGroup(group, max);
    }
  });
}

function initSingleGroup(group) {
  queryAll('[data-add-on]', group).forEach(card => {
    const btn  = card.querySelector('.add-on__add-btn');
    const name = card.dataset.name || '';

    btn.addEventListener('click', () => {
      const wasSelected = card.classList.contains('is-selected');

      // Deselect all cards in the group
      queryAll('[data-add-on]', group).forEach(c => {
        c.classList.remove('is-selected');
        const b = c.querySelector('.add-on__add-btn');
        b.textContent  = 'Add';
        b.setAttribute('aria-pressed', 'false');
        b.setAttribute('aria-label', `Add ${c.dataset.name || ''}`);
      });

      // If the clicked card was not already selected, select it
      if (!wasSelected) {
        card.classList.add('is-selected');
        btn.textContent = 'Remove';
        btn.setAttribute('aria-pressed', 'true');
        btn.setAttribute('aria-label', `Remove ${name}`);
      }
    });
  });
}

function initGiftCardGroup(group) {
  queryAll('[data-add-on]', group).forEach(card => {
    const name = card.dataset.name || '';

    card.addEventListener('click', () => {

      queryAll('[data-add-on]', group).forEach(c => {
        c.classList.remove('is-selected');
        c.setAttribute('aria-pressed', 'false');
        c.setAttribute('aria-label', `Select ${c.dataset.name || ''}`);
      });

      card.classList.add('is-selected');
      card.setAttribute('aria-pressed', 'true');
      card.setAttribute('aria-label', `Deselect ${name}`);
    });
  });
}

function initMultipleGroup(group, max) {
  queryAll('[data-add-on]', group).forEach(card => {
    const addBtn     = card.querySelector('.add-on__add-btn');
    const qtyControl = card.querySelector('.add-on__qty-control');
    const qtyValue   = card.querySelector('.add-on__qty-value');
    const minusBtn   = card.querySelector('.add-on__qty-btn--minus');
    const plusBtn    = card.querySelector('.add-on__qty-btn--plus');

    function groupTotal() {
      return queryAll('[data-add-on].is-selected', group).reduce((sum, c) => {
        const v = c.querySelector('.add-on__qty-value');
        return sum + (v ? parseInt(v.textContent, 10) || 0 : 0);
      }, 0);
    }

    function syncGroupButtons() {
      const atMax = groupTotal() >= max;
      queryAll('[data-add-on]', group).forEach(c => {
        if (c.classList.contains('is-selected')) {
          const pb = c.querySelector('.add-on__qty-btn--plus');
          if (pb) pb.disabled = atMax;
        } else {
          const ab = c.querySelector('.add-on__add-btn');
          if (ab) ab.disabled = atMax;
        }
      });
    }

    function setQty(qty) {
      qtyValue.textContent = qty;
    }

    addBtn.addEventListener('click', () => {
      card.classList.add('is-selected');
      addBtn.hidden      = true;
      qtyControl.hidden  = false;
      setQty(1);
      syncGroupButtons();
    });

    minusBtn.addEventListener('click', () => {
      const qty = parseInt(qtyValue.textContent, 10) - 1;
      if (qty <= 0) {
        card.classList.remove('is-selected');
        qtyControl.hidden = true;
        addBtn.hidden     = false;
      } else {
        setQty(qty);
      }
      syncGroupButtons();
    });

    plusBtn.addEventListener('click', () => {
      if (groupTotal() < max) {
        setQty(parseInt(qtyValue.textContent, 10) + 1);
        syncGroupButtons();
      }
    });

    syncGroupButtons();
  });
}
